class ImagesGallery {
    constructor($el) {
        this.$el = $el;

        this.$mainImage = this.$el.find('.images-gallery__picture--main');
        this.$thumbnailsImages = this.$el.find('.images-gallery__picture--thumbnail');
        this.$thumbnailsGallery = this.$el.find('.images-gallery__thumbnails:not(.images-gallery__thumbnails--not-full)');

        if(this.$el.length && this.$mainImage.length && this.$thumbnailsImages.length) {
            this._bindEvents();

            if(this.$thumbnailsGallery.length) {
                this._createThumbnailsGallery();
            }
        }
    }

    _bindEvents() {
        this.$thumbnailsImages.on('click', this.updateMainImage.bind(this));
        this.$thumbnailsImages.on('mouseenter', this.updateMainImage.bind(this));
    }

    _createThumbnailsGallery() {
        this.scrollbar = new SimpleBar(this.$thumbnailsGallery[0]);
    }

    updateMainImage(e) {
        const $target = $(e.currentTarget);

        this.$mainImage.attr('src', $target.attr('src'));
    }
}

export default ImagesGallery;
